export default __webpack_public_path__ + "static/media/react.da057b4c.svg";